<template>
    <v-btn
        :color="color"
        @click="remove"
        :loading="loading"
        :disabled="loading"
        rounded
        :icon="icon"
        :large="large"
    >
        <template v-if="icon">
            <v-icon v-if="confirm">help</v-icon>
            <v-icon v-else>delete</v-icon>
        </template>
        <template v-else>
            <span v-t="'button.confirm_delete'" v-if="confirm"></span>
            <v-icon>delete</v-icon>
        </template>
    </v-btn>
</template>
<script>
export default {
    props: {
        color: { type: String, default: "error" },
        loading: { type: Boolean, default: false },
        icon: { type: Boolean, default: false },
        large: { type: Boolean, default: false },
    },
    data() {
        return {
            confirm: false,
        }
    },
    methods: {
        remove(e) {
            if (this.confirm) {
                this.confirm = false
                this.$emit("click", e)
            }
            this.confirm = true
        },
    },
}
</script>
